export class ChangePassword{
  oldPassword: string = "";
  pin: string = "";
  password: string = "";
}